import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  container: {
    border: `1px dashed ${theme.custom.darkBlue}`,
    padding: '10px 20px',
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '25px 50px',
    [theme.breakpoints.down(theme.size.sm)]: {
      padding: 20,
    },
    [theme.breakpoints.down(theme.size.xs)]: {
      padding: 10,
    },
  },
  text: {
    marginRight: 10,
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    lineHeight: 1,
    color: theme.custom.darkBlue,
  },
  btn: {
    minWidth: 'auto',
    padding: '7px 15px',
    fontSize: 14,
    fontWeight: 600,
    fontFamily: 'NeoSansStd',
    lineHeight: 1,
    color: '#347AC4',
    border: '2px solid #3275BC',
    borderRadius: 29,
    textTransform: 'uppercase',
  },
  inputFile: {
    display: 'none',
  },
}));
